import { create } from 'zustand';

type UiState = {
  globalLoadingVisible: boolean;
};

type UiActions = {
  showGlobalLoading: () => void;
  hideGlobalLoading: () => void;
  setGlobalLoading: (visible: boolean) => void;
};

const initialState: UiState = {
  globalLoadingVisible: false,
};

export const useUiStore = create<UiState & UiActions>(set => ({
  ...initialState,
  showGlobalLoading: () => set({ globalLoadingVisible: true }),
  hideGlobalLoading: () => set({ globalLoadingVisible: false }),
  setGlobalLoading: visible => set({ globalLoadingVisible: visible }),
}));

/**
 * Imperative helpers for non-React contexts (e.g. services).
 */
export const globalLoading = {
  show: () => useUiStore.getState().showGlobalLoading(),
  hide: () => useUiStore.getState().hideGlobalLoading(),
  set: (visible: boolean) => useUiStore.getState().setGlobalLoading(visible),
};
